import { css } from '@emotion/react';

/* eslint-disable max-len */
export const dialogCloseBtnCss = css`
	&.MuiIconButton-root {
		position: absolute;
		right: 3px;
		top: 4px;
	}
`;

export const dialogZIndex = (zIndex: number) => css`
	.MuiDialog-root,
	.MuiPopover-root {
		z-index: ${zIndex} !important;
	}
`;
